import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { BankMasterModel } from "src/app/model/BankMasterModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-bank-master-list",
  templateUrl: "./bank-master-list.component.html",
  styleUrls: ["./bank-master-list.component.scss"],
})
export class BankMasterListComponent implements OnInit {
  page: Page<BankMasterModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<BankMasterModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "ifsc",
    "bankName",
    "branchName",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService.fetchBankMasterList(this.currentPage, 
      this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Bank Master", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  edit(key: number) {
    this.router.navigate(['/secure', 'bank-master', 'au', key]);
  }

  delete(key: number) {
    if(confirm("Do you want to delete the Bank Master")) {
      this.masterService.deleteBankMaster(key).subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          this.masterService.successToast("Bank Master has been deleted successfully.");
          this.onLoad();
        }
        else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
    } 
  }

}